﻿﻿﻿<!--<escalator-menu (outputDownload)="downloadEscalatorFiltered()" (onReload)="onReload()"></escalator-menu>-->
<escalator-filter (outputFilter)="getFilteredEscalatorsByTenant()"></escalator-filter>
<escalator-list [list]="list" [showLocalFilter]="showLocalFilter"></escalator-list>